import { createSelector } from 'reselect'
import { formValueSelector } from 'redux-form'
import { filter as fuzz } from 'fuzzaldrin-plus'

import {
  RAW_STATUSES,
  ANY_DATATYPE,
  ANY_FILETYPE,
  ANY_SCHEMA_TYPE
} from 'webmango-core/selectors/schema'

export * from 'webmango-core/selectors'

// ----
// LOAD/SYNC STATE SELECTORS
// ----

const getSync = state => state.sync

export const isReady = createSelector([ getSync ], (sync) => {
  return (
    !sync.isInitial &&
    !sync.isInitialInProgress
  )
})

export const needsSync = createSelector([ getSync ], (sync) => {
  return (
    !sync.inProgress &&
    sync.isDirty
  )
})

export const getSelectedValue = state => state.selection.value

/**
 * Filtering
 */

const filterByStatus = (schemas, status) => {
  if (!status || status === 'devel') return schemas
  const level = RAW_STATUSES.indexOf(status)
  return schemas.filter(schema => {
    return RAW_STATUSES.indexOf(schema.status) <= level
  })
}

const filterByDatatype = (schemas, datatype) => {
  if (!datatype || datatype === ANY_DATATYPE) return schemas
  return schemas.filter(schema => {
    const inputTypes = Object.keys(schema.types || {})
    if (!inputTypes.length) return true
    return inputTypes.includes(datatype)
  })
}

const filterByFiletype = (schemas, filetype) => {
  if (!filetype || filetype === ANY_FILETYPE) return schemas
  if (filetype !== 'netcdf') {
    // special handling for Import_Data_File
    return [schemas.find(s => s.name === 'Import_Data_File')]
  } else {
    return schemas.filter(s => s.name !== 'Import_Data_File')
  }
}

const filterByType = (schemas, type) => {
  schemas = schemas.filter(s => s.type !== 'inputdata')
  if (!type || type === ANY_SCHEMA_TYPE) return schemas
  return schemas.filter(schema => {
    return schema.type === type
  })
}

const filterByName = (schemas, name) => {
  if (!name) return schemas
  return fuzz(schemas, name, {key: 'name'})
}

const filterSearchSelector = formValueSelector('filterSearch')

const filters = state => state.schemas && state.schemas.filters
const mangoFilters = createSelector([ filters ], (filters) => filters && Object.values(filters))
export const mangoSchemaSearch = createSelector([
  mangoFilters,
  state => filterSearchSelector(state, 'status'),
  state => filterSearchSelector(state, 'datatype'),
  state => filterSearchSelector(state, 'filetype'),
  state => filterSearchSelector(state, 'search'),
  state => filterSearchSelector(state, 'type')
], (schemas = [], status, datatype, filetype, search, type) => {
  return uniqueBy(
    filterByName(
      filterByType(
        filterByDatatype(
          filterByStatus(
            filterByFiletype(schemas, filetype),
            status
          ),
          datatype
        ),
        type
      ),
      search
    ),
    'name'
  )
})

function uniqueBy (items = [], key) {
  const seen = new Set()
  return items.filter(s => {
    if (seen.has(s[key])) return false
    seen.add(s[key])
    return true
  })
}



// WEBPACK FOOTER //
// ./src/selectors.js